module.exports = __webpack_public_path__ + "img/page.1a13d656.png";